var React = require('react');

function SmallCircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"shape/circle","transform":"translate(3.000000, 3.000000)","stroke":"#F5A623","strokeWidth":"6"},React.createElement("circle",{"id":"Oval","cx":"16","cy":"16","r":"16"})))]);
}

SmallCircle.defaultProps = {"width":"38px","height":"38px","viewBox":"0 0 38 38","version":"1.1"};

module.exports = SmallCircle;

SmallCircle.default = SmallCircle;
